import type { ActivityStyledConfig } from "../types";
import { ACTIVITY_TYPE } from "@/constants/activity";

import heroPromoPage from "@/assets/images/activity/2026/618Promotion/power-hero-promo-v2.webp";
import heroRenewalPage from "@/assets/images/activity/2026/618Promotion/power-hero-renewal-v2.webp";
import heroPromoModal from "@/assets/images/activity/2026/618Promotion/model-hero-promo.webp";
import heroRenewalModal from "@/assets/images/activity/2026/618Promotion/model-hero-renewal.webp";

/**
 * 618 促销活动配置（样式化方案）
 * Tab + 卡片走 VipPackageV2/MemberTabV2；仅 Hero 装饰随 theme 切换。
 */
export const promotion618Config: ActivityStyledConfig = {
  kind: "styled",
  activityType: ACTIVITY_TYPE.PROMOTION_618,
  tabOptions: [
    { label: "按月购买", value: "subscribe", discountBadge: "限时 29.9 元" },
    { label: "按季购买", value: "season", discountBadge: "低至7.4折" },
    { label: "按年购买", value: "year" },
    { label: "团队使用", value: "group", discountBadge: "最低5折" }
  ],
  discountLabels: {
    subscribe: "限时29.9",
    season: null,
    year: null
  },
  pricingTable: {
    subscribe: {},
    season: {},
    year: {}
  },
  packagePricingTable: {
    subscribe: {
      neverPaid: {
        vip: { type: "fixed", value: 29.9 },
        svip: { type: "fixed", value: 29.9 }
      },
      expired: {
        vip: { type: "fixed", value: 29.9 },
        svip: { type: "fixed", value: 29.9 }
      },
      activeVipSvip: {
        vip: { type: "fixed", value: 99 },
        svip: { type: "fixed", value: 59, eligibleCurrentPackages: ["vip"] },
        ultra: { type: "fixed", value: 259, eligibleCurrentPackages: ["vip", "svip"] }
      }
    },
    year: {
      expired: {
        vip: { type: "fixed", value: 820 },
        svip: { type: "fixed", value: 1648 },
        ultra: { type: "fixed", value: 3539 }
      },
      activeVipSvip: {
        svip: { type: "fixed", value: 1429, eligibleCurrentPackages: ["vip"] },
        ultra: { type: "fixed", value: 3079, eligibleCurrentPackages: ["vip", "svip"] }
      }
    }
  },
  themes: {
    promo: {
      assets: {
        heroPage: heroPromoPage,
        heroModal: heroPromoModal
      }
    },
    renewal: {
      assets: {
        heroPage: heroRenewalPage,
        heroModal: heroRenewalModal
      }
    }
  },
  sharedTokens: {
    countdownColor: "#fff",
    countdownTopPage: "246px",
    countdownTopModal: "56px",
    tabActiveGradient: "#8C5BEC",
    tabInactiveBg: "#202024"
  },
  trialSubscribePresentation: {
    segments: ["neverPaid", "expired"],
    vip: {
      trialPower: 1500,
      trialDaysLabel: "31天",
      dailyPriceYuan: "0.97",
      perHundredYuan: "1.99",
      powerSignText: "1500算力试用",
      powerBarPrefix: "31天",
      buttonLabel: "29.9元解锁VIP",
      offerInfo: "29.9元试用回归礼+续费8.8折",
      renewFootnote: "试用结束后按8.8折续费，发放3000算力/月"
    },
    svip: {
      trialPower: 2000,
      trialDaysLabel: "15天",
      dailyPriceYuan: "1.99",
      perHundredYuan: "1.50",
      powerSignText: "2000算力试用",
      powerBarPrefix: "15天",
      buttonLabel: "29.9元解锁SVIP",
      offerInfo: "29.9元试用回归礼+续费8.8折",
      renewFootnote: "试用结束后按8.8折续费，发放4500算力/半月"
    },
    packageCopyBySegment: {
      neverPaid: {
        vip: { offerInfo: "首购29.9元试用+续费8.8折" },
        svip: { offerInfo: "首购29.9元试用+续费8.8折" }
      }
    }
  }
};
